import type { SVGProps } from 'react';

export default function SvgIconStockAmount(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.7561 9.65067V4.76414C14.7555 4.64538 14.7235 4.52888 14.6635 4.4264C14.6035 4.32392 14.5175 4.23907 14.4142 4.18043L10.0865 1.45823C9.98767 1.40115 9.87551 1.37109 9.76134 1.37109C9.64716 1.37109 9.535 1.40115 9.43613 1.45823L2.09799 5.58593C1.99472 5.64458 1.90873 5.72942 1.84871 5.8319C1.78868 5.93439 1.75674 6.05088 1.7561 6.16965V11.0562C1.75674 11.1749 1.78868 11.2914 1.84871 11.3939C1.90873 11.4964 1.99472 11.5812 2.09799 11.6399L6.42566 14.3621C6.52453 14.4192 6.6367 14.4492 6.75087 14.4492C6.86504 14.4492 6.9772 14.4192 7.07608 14.3621L14.4142 10.2344C14.5175 10.1757 14.6035 10.0909 14.6635 9.98841C14.7235 9.88593 14.7555 9.76943 14.7561 9.65067Z"
        stroke="#FF001A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"></path>
      <path
        d="M14.6644 4.42188L6.82598 8.87479L2.41479 6.30274"
        stroke="#FF001A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"></path>
      <path
        d="M6.82603 8.875L6.75098 14.4453"
        stroke="#FF001A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"></path>
    </svg>
  );
}
